<template>
  <div class="studentDetails">
    <div class="topTitle">
      <el-page-header @back="goBack">
        <template #content>
          <span class="text-large font-600 mr-3"> 点评详情 </span>
        </template>
      </el-page-header>
    </div>
    <div class="stuInfo" style="margin-top: 10px;">
      <ul style="overflow: hidden;">
        <li class="fl" style="width: 33%;">
          上课时间：{{ workInfo.start_class_date }}
        </li>
        <li class="fl" style="width: 33%;">
          授课课程：{{ workInfo.lessonTitle }}
        </li>
        <li class="fl" style="width: 33%;">
          点名时间：{{ workInfo.tchPlanSignData }}
        </li>
        <li class="fl" style="width: 33%;">
          上课老师：{{ workInfo.lecturerName }}
        </li>
        <li class="fl" style="width: 33%;">
          班级名称：{{ workInfo.className }}
        </li>
        <li class="fl" style="width: 33%;">
          上课内容：{{ workInfo.lessonTitle }}
        </li>
      </ul>
    </div>
    <div class="studentMain" style="margin-top: 10px;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="点评学员" name="first">
          <el-form @submit.native.prevent ref="form" :model="CourseworkForm1" :inline="true" size="mini">
            <!-- <el-form-item label="学员名称">
                            <el-input clearable style="width: 200px" v-model="CourseworkForm1.title" placeholder="请输入作品名称"
                                @keyup.enter.native="search4"></el-input>
                        </el-form-item> -->
            <el-form-item label="点评状态">
              <el-select v-model="CourseworkForm1.evaluateState" placeholder="请选择" style="width: 200px" clearable @change="search4">
                <el-option label="已评价" value="1"></el-option>
                <el-option label="待评价" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出勤状态">
              <el-select v-model="CourseworkForm1.sign_state" placeholder="请选择" style="width: 200px" clearable @change="search4">
                <el-option label="出勤" value="1"></el-option>
                <el-option label="缺勤" value="2"></el-option>
                <el-option label="未签到" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item size="mini">
              <el-button size="mini" type="primary" @click="search4" icon="el-icon-search">查询
              </el-button>
            </el-form-item>
          </el-form>
          <el-table ref="multipleTable" :data="tableData1" tooltip-effect="dark" style="width: 100%;" :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }" stripe>
            <el-table-column prop="" label="头像" width="60">
              <template slot-scope="scope">
                <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
                  <img :src="scope.row.stu_headImgUrl" style="width: 100%;" />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="stu_name" label="学员姓名">
              <template slot-scope="scope">
                <span v-if="scope.row.stu_tch_plan_type == '1'">{{ scope.row.stu_name }}
                </span>
                <span v-else-if="scope.row.stu_tch_plan_type == '2'">{{ scope.row.stu_name
                  }}<span style="color: #e6a23c">(试听)</span></span>
                <span v-else-if="scope.row.stu_tch_plan_type == '3'">{{ scope.row.stu_name
                  }}<span style="color: #e6a23c">(调课)</span></span>
                <span v-else-if="scope.row.stu_tch_plan_type == '4'">{{ scope.row.stu_name
                  }}<span style="color: #e6a23c">(补课)</span></span>
                <span v-else-if="scope.row.stu_tch_plan_type == '5'">{{ scope.row.stu_name
                  }}<span style="color: #e6a23c">(临加)</span></span>
              </template>
            </el-table-column>

            <el-table-column prop="stu_username" label="平台账号"></el-table-column>

            <el-table-column label="出勤状态">
              <template slot-scope="scope">
                <span v-if="scope.row.stu_tch_plan_type === 1">
                  <span v-if="scope.row.sign_state == 1">
                    已出勤
                  </span>
                  <span v-if="scope.row.sign_state == 2">
                    缺勤
                  </span>
                  <span v-if="scope.row.sign_state == null">
                    未签到
                  </span>
                </span>
                <span v-if="scope.row.stu_tch_plan_type === 4">
                  <span v-if="scope.row.sign_state == 1">
                    已补课
                  </span>
                  <span v-if="scope.row.sign_state == 2">
                    缺勤
                  </span>
                  <span v-if="scope.row.sign_state == null">
                    未签到
                  </span>
                </span>
                <span v-if="scope.row.stu_tch_plan_type === 5">
                  <span v-if="scope.row.sign_state == 1">
                    已出勤
                  </span>
                  <span v-if="scope.row.sign_state == 2">
                    缺勤
                  </span>
                  <span v-if="scope.row.sign_state == null">
                    未签到
                  </span>
                </span>
              </template>
            </el-table-column>

            <el-table-column label="点名时间" width="200">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.sign_date }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="微信通知">
              <template slot-scope="scope">
                <span v-if="$store.state.user.schoolInfo.authorize">
                  <span v-if="scope.row.stu_authorizer_openid">
                    已绑定
                  </span>
                  <span v-else>绑定微信后可收到通知</span>
                </span>
                <span v-else>
                  <span v-if="scope.row.stu_openid">
                    <span>
                      <div style="overflow: hidden;">
                        <div style="float: left;margin-top: -3px;margin-left: 5px;">
                          已绑定
                        </div>
                      </div>
                    </span>
                  </span>
                  <span v-else>绑定微信后可收到通知</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="课堂作品">
              <template slot-scope="scope">
                <span v-if="scope.row.classWorkState == true"><span style="color:green;font-size:14px;">◉ 已提交</span></span>
                <span v-else><span style="font-size:14px;">◉ 未提交</span></span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="作业">
              <template slot-scope="scope">
                <span v-if="scope.row.homeWorkState == true"><span style="color:green;font-size:14px;">◉ 已提交</span></span>
                <span v-else><span style="font-size:14px;">◉ 未提交</span></span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="阅读/已评">
              <template slot-scope="scope">
                <span>
                  <el-link @click="detailsComment(scope.row)" type="primary">
                    {{ scope.row.evaluatereadCount }}

                    /

                    {{ scope.row.evaluateCount }}</el-link>
                </span>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="evaluate(scope.row)">点评学员</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChange1" :current-page="page_no1" :page-size="page_size1" layout="total,prev, pager, next" :total="total1"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="点评作品" name="second">
          <el-form @submit.native.prevent ref="form" :model="CourseworkForm" :inline="true" size="mini">
            <el-form-item label="作品名称">
              <el-input clearable style="width: 200px" v-model="CourseworkForm.title" placeholder="请输入作品名称" @keyup.enter.native="search3"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="CourseworkForm.type" placeholder="请选择" style="width: 200px" clearable @change="search3">
                <el-option label="全部" value=""></el-option>
                <el-option label="课堂" value="1"></el-option>
                <el-option label="作业" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="点评状态">
              <el-select v-model="CourseworkForm.is_marking" placeholder="请选择" style="width: 200px" clearable @change="search3">
                <el-option label="全部" value=""></el-option>
                <el-option label="已评价" value="1"></el-option>
                <el-option label="待评价" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item size="mini">
              <el-button size="mini" type="primary" @click="search3" icon="el-icon-search">查询
              </el-button>
            </el-form-item>
          </el-form>
          <el-table :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }" stripe ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <el-table-column align="center" width="50" label="序号" fixed="left">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 + (page_no - 1) * page_size }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="姓名" fixed="left">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.username" placement="top">
                  <span>{{ scope.row.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="类型" align="left">
              <template slot-scope="scope">
                <span v-if="scope.row.work_type == '1'">课堂</span>
                <span v-else-if="scope.row.work_type == '2'">作业</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="封面" width="100">
              <template slot-scope="scope">
                <el-image style="width: 24px; height: 18px" :src="scope.row.covers" fit="cover" @click="LookOneWork(scope.row)"></el-image>
              </template>
            </el-table-column>

            <el-table-column label="作品名称" align="left" width="200">
              <template slot-scope="scope">
                <span @click="LookOneWork(scope.row)">{{
                  scope.row.title
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="作品简介" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.abstract"> {{ scope.row.abstract }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column property="created_time" label="提交时间" align="left" width="200"></el-table-column>
            <el-table-column property="update_time" label="更新时间" align="left" width="200"></el-table-column>
            <el-table-column align="center" label="已评价" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>
                  <span v-if="scope.row.is_marking == false">0</span>
                  <span v-if="scope.row.is_marking == true">1</span>
                  / 1
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button v-if="workInfo.subjectCode === 4" type="text" size="mini" @click="goDetails(scope.row)">查看</el-button>
                <el-button v-else type="text" size="mini" @click="LookOneWork(scope.row)">查看</el-button>
                <el-button type="text" size="mini" @click="evaluate1(scope.row)">点评</el-button>
                <!-- 推送1 -->
                <!-- <el-button v-if="$store.state.user.schoolInfo.authorize" type="text" size="mini"
                                    :disabled="!scope.row.is_marking || !scope.row.authorizer_openid
                                        " @click="sendTchWorkTchCommentTemplateMessage(scope.row)">推送</el-button>
                                <el-button v-else type="text" size="mini"
                                    :disabled="!scope.row.is_marking || !scope.row.openid"
                                    @click="sendTchWorkTchCommentTemplateMessage(scope.row)">推送</el-button> -->
                <el-button type="text" size="mini" v-if="workInfo.subjectCode == 2 || workInfo.subjectCode == 1" @click="CreatBill(scope.row)">海报</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page="page_no" :page-size="page_size" layout="total,prev, pager, next" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-drawer class="comment" title="作品点评" :visible.sync="dialogFormVisible2" :size="widthSize" :with-header="false" :wrapperClosable="false">
      <div style="overflow: hidden; padding:20px">
        <div :style="{
            width:
              isShowCommonPhrases == false
                ? '100%'
                : 'calc(100% / 1.75 - 2px )',
          }" style="float: left; ">
          <div style="height: calc(100vh - 48px); overflow-y: auto; ">
            <el-form :model="markform" ref="ruleForm" label-width="200px" label-position="top" size="mini" class="demo-ruleForm">
              <el-form-item label="">
                <div style="overflow: hidden;">
                  <div style="font-size: 16px;" class="fl">
                    <span>辛苦老师，请为</span>
                    <span style="color:#1773DC;font-weight: bold;">
                      {{ stu_name }}
                    </span>
                    <span>进行课程评价吧！</span>
                  </div>
                  <div @click="handleClose2" class="fr" style="cursor: pointer; font-size: 16px;">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="作品等级">
                <el-rate v-model="markform.markpoint"> </el-rate>
              </el-form-item>
              <div>
                <el-form-item label="作品推优" v-if="this.workInfo.subjectCode != 4">
                  <el-switch v-model="markform.is_good"></el-switch>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="源码加密" v-if="this.workInfo.subjectCode != 4">
                  <el-switch v-model="markform.is_only"></el-switch>
                </el-form-item>
              </div>

              <el-form-item label="">
                <span style="font-weight:bold;">作品评语</span><span style="cursor: pointer;color:#1773DC" @click="isShowCommonPhrases = true">【常用语】</span>
                <span style="cursor: pointer;color:#1773DC" @click="generate_ai">【帮我想一段】</span>

                <el-input style="max-height:200px;font-size:14px;" type="textarea" v-model="markform.remark" :autosize="{ minRows: 4, maxRows: 10 }" :maxlength="1000" show-word-limit></el-input>
              </el-form-item>
            </el-form>

            <div class="demo-drawer__footer" style="text-align:right;margin-top: 20px;">
              <el-button type="primary" size="small" @click="tchSaveTchWorkScore">点 评</el-button>
              <span v-if="$store.state.user.schoolInfo.authorize">
                <el-button type="primary" size="small" v-if="($store.state.user.schoolInfo.authorize && stu_authorizer_openid) || stu_openid" @click="all" style="margin-left: 10px;">点评并推送</el-button>
                <el-button type="primary" size="small" v-else @click="all('notPush')" style="margin-left: 10px;">点评</el-button>
              </span>
            </div>
          </div>
        </div>
        <div v-if="isShowCommonPhrases" style="width:1px;height: calc(100vh - 48px); background: #f2f2f2;float: left;margin-left: 5px; margin-right: 5px;"></div>
        <div v-if="isShowCommonPhrases" style="width: calc(100% - 100% / 1.75 - 9px);float: left; ">
          <div v-if="isShowCommonPhrases1" style="height: calc(100vh - 48px); overflow-y: auto; position: relative;">
            <div style="margin-left: 20px;">
              <div style="overflow: hidden;">
                <div class="fl" style="font-size: 16px; margin-bottom: 10px;font-weight:bold">
                  常用语
                </div>
                <div @click="isShowCommonPhrases = false" class="fr" style="font-size: 16px; margin-bottom: 10px;font-weight:bold ;cursor: pointer;">
                  <i class="el-icon-close"></i>
                </div>
              </div>
              <div v-if="tagList.length === 0">
                <el-empty description="暂无评语"></el-empty>
              </div>
              <div v-else @click="SetComment(item.remark)" v-for="(item, index) in tagList" :key="index" style="cursor: pointer;padding: 3px;margin-bottom: 10px;border-bottom:1px solid #f2f2f2;padding-bottom: 10px;">
                <div style="overflow: hidden; ">
                  <div class="txttag" style="width:100%">
                    <span style="word-break: break-all;">{{
                      item.remark
                    }}</span>
                    <span class="BtnShow" style="margin-right: 10px; text-align: right; " @click.stop="editremark(item)">
                      <el-button type="text" size="mini">编辑</el-button>
                    </span>
                    <span class="BtnShow" style="margin-right: 10px; text-align: right;" @click.stop="delremark(item)">
                      <el-button type="text" size="mini">删除</el-button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div style="position:fixed;right:2%;bottom:4%" @click="addremark">
              <div style="width:60px;height: 60px;border-radius: 50%;background-color:#6190F6;">
                <div style="cursor: pointer;position:absolute;width:16px;height:16px;color:#fff;font-size:16px;top:50%;left:50%;margin-top:-8px;margin-left:-8px" class="el-icon-plus"></div>
              </div>
            </div>
          </div>
          <div v-else style="height: calc(100vh - 48px); overflow-y: auto; position: relative;">
            <el-page-header @back="goBack1" content="常用语"> </el-page-header>
            <div style="margin-top:20px;main-left:20px">
              <el-input :autosize="{ minRows: 4, maxRows: 10 }" type="textarea" placeholder="请输入常用语" v-model="remark">
              </el-input>
              <div style="margin-top:20px;overflow:hidden">
                <!-- <el-button @click="dialogVisible5 = false">取 消</el-button> -->
                <el-button style="float:right" type="primary" @click="sumbit5" size="mini">保 存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="常用语" :visible.sync="dialogVisible5">
      <el-input type="textarea" placeholder="请输入常用语" v-model="remark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="sumbit5">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="点评学员" :visible.sync="drawer1" :size="widthSize" :with-header="false" style="overflow: hidden;" :wrapperClosable="false">
      <div style="overflow: hidden; padding:20px">
        <div :style="{
            width:
              isShowCommonPhrases == false
                ? '100%'
                : 'calc(100% / 1.75 - 30px + 10px)',
          }" style="float: left; ">
          <div style="height: calc(100vh - 48px); overflow-y: auto;">
            <div>
              <el-form :model="markform" ref="ruleForm" label-width="200px" label-position="top" size="mini" class="demo-ruleForm">
                <el-form-item label="">
                  <div style="overflow: hidden;">
                    <div style="font-size: 16px;" class="fl">
                      <span>辛苦老师，请为</span>
                      <span style="color:#1773DC;font-weight: bold;">
                        {{ stu_name }}
                      </span>
                      <span>进行课程评价吧！</span>
                    </div>
                    <div @click="handleClose1" class="fr" style="cursor: pointer; font-size: 16px;">
                      <i class="el-icon-close"></i>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="">
                  <el-table :data="tableDataWork" style="width: 100%" size="mini" :header-cell-style="{
                      background: '#f5f7fa',
                      color: '#606266',
                      'font-size': '14px',
                    }" stripe>
                    <el-table-column prop="" label="封面">
                      <template slot-scope="scope">
                        <el-image style="width: 24px; height: 18px" :src="scope.row.covers" fit="cover"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column prop="" label="作品名称">
                      <template slot-scope="scope">
                        <span>{{ scope.row.title }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="" label="类型">
                      <template slot-scope="scope">
                        <span v-if="scope.row.work_type == '1'">课堂</span>
                        <span v-else-if="scope.row.work_type == '2'">作业</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="left" label="作品简介" :show-overflow-tooltip="true">
                      <template slot-scope="scope">
                        <span v-if="scope.row.abstract">
                          {{ scope.row.abstract }}</span>
                        <span v-else>--</span>
                      </template>
                    </el-table-column>
                    <el-table-column property="created_time" label="提交时间" align="left" width="200"></el-table-column>
                    <el-table-column property="update_time" label="更新时间" align="left" width="200"></el-table-column>
                    <el-table-column prop="" align="center" label="操作" fixed="right">
                      <template slot-scope="scope">
                        <el-button v-if="workInfo.subjectCode === 4" type="text" size="mini" @click="goDetails(scope.row)">查看</el-button>
                        <el-button v-else type="text" size="mini" @click="LookOneWork1(scope.row)">查看</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>

                <el-form-item label="">
                  <template v-for="(item, index) in scoreList">
                    <div :key="index">
                      <span style="font-weight:bold;">{{ item.title }}</span>
                      <el-rate style="margin-top:10px;margin-bottom:10px;" v-model="item.star" @change="handleChangeRate($event, item)">
                      </el-rate>
                    </div>
                  </template>
                  <span style="color:#e4393c;fontSize:12px">注：不点评星级，学习报告不显示此标签</span>
                </el-form-item>
                <!-- 发放星币 -->
                <el-form-item label="" v-if="showGrant">
                  <span style="font-weight:bold;">奖励星币</span>
                  <div style="padding-top: 10px;">
                    <el-input-number v-model="markform.grantStarNum" :precision="0"></el-input-number>
                    <span style="padding-left:10px;color:#888;">注：请输入奖励学生的星币数量
                      <span v-if="starNumLimit !== 0">
                        ,最多奖励 <b>{{ starNumLimit }}</b> 星币
                      </span>
                    </span>
                  </div>
                </el-form-item>
                <el-form-item label="">
                  <span style="font-weight:bold;">作品评语</span><span style="cursor: pointer;color:#1773DC" @click="isShowCommonPhrases = true">【常用语】</span>
                  <span style="cursor: pointer;color:#1773DC" @click="generate_ai">【帮我想一段】</span>

                  <el-input style="max-height:200px;font-size:14px;" type="textarea" v-model="markform.remark" :autosize="{ minRows: 4, maxRows: 10 }" :maxlength="1000" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="">
                  <div style="border: 1px solid #ccc; padding: 5px;">
                    <span style="font-size: 16px;cursor: pointer;" @click="isShowTime"><i class="el-icon-microphone"></i></span>
                    <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove1" :on-change="handleChangeFile1" :limit="9" :file-list="fileList1" list-type="" style="width: 20px;display: inline-block;margin-left: 10px;">
                      <span><i class="el-icon-picture-outline"></i></span>
                    </el-upload>
                    <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile" :limit="3" :file-list="train_videoList" list-type="" style="width: 100px;display: inline-block;margin-left: 10px;">
                      <span><i class="el-icon-video-camera"></i></span>
                    </el-upload>
                  </div>
                </el-form-item>
                <div v-if="isShow" class="soundRecording" style="width: 300px;padding: 10px;background: #fff;border: 1px solid #ccc;">
                  <div style="overflow: hidden;">
                    <div class="fl">
                      <div style="overflow: hidden;" v-if="isShow1">
                        <div class="fl">
                          <img src="https://image.xiaomaiketang.com/xm/xCahGm2Q2J.png" style="width: 14px;height: 14px;" />
                        </div>
                        <div style="margin-top: -2px;" class="fl">录音</div>
                      </div>
                      <div v-else style="overflow: hidden;">
                        <div class="fl">
                          <img src="https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1584607726775.png" style="width: 14px;height: 14px;" />
                        </div>
                        <div style="margin-top: -2px;" class="fl">录音中</div>
                      </div>
                      <div v-if="isShow1">00:00/03:00</div>
                      <div v-else>{{ time }} / 03:00</div>
                    </div>
                    <div class="fr" style="line-height: 36px;">
                      <el-button size="mini" @click="qx">取消</el-button>
                      <el-button size="mini" v-if="isShow1" type="primary" @click="startRecording">开始</el-button>
                      <el-button size="mini" v-else type="danger" @click="handleStop">停止</el-button>
                    </div>
                  </div>
                </div>

                <div v-for="(item1, index1) in attachment" :key="index1">
                  <div v-if="item1.type === 'voice'">
                    <div style="overflow:hidden">
                      <div class="fl">
                        <audio class="audioStyle" width="222" height="40" controls>
                          <source :src="item1.url" type="audio/ogg" />
                        </audio>
                      </div>
                      <div class="fl" style="line-height:40px">
                        <span @click="colse(item1)"><i class="el-icon-error" style="color:#ccc;font-size:18px;margin-left:10px"></i></span>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>
                <draggable v-model="attachment" group="people" @change="change" @start="start" @end="end">
                  <div @mouseover="showButton1(index1)" @mouseleave="hideButton(index1)" v-for="(item1, index1) in attachment" :key="index1" style="display:inline-block;margin-top:10px">
                    <div style="display:inline-block;margin-left: 10px;" v-if="item1.type === 'img'">
                      <div style="position:relative">
                        <img :src="item1.url" style="height: 60px;" />
                        <span style="position:absolute;top:0;right:0; z-index: 100;">
                          <span @click="colse(item1)"><i class="el-icon-error" style="color:#ccc;font-size:16px;"></i></span>
                        </span>
                        <div v-if="showButton === index1" style="position: absolute;width: 100%;height:60px; background-color: rgba(0, 0, 0, 0.5); z-index: 99; top:0;left:0">
                          <div style="width: 16px;height: 16px; position: absolute;top: 50%;left: 50%;margin-top: -8px;margin-left: -8px;">
                            <i class="el-icon-rank" style="color: #fff;font-size: 16px;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="display:inline-block;margin-left: 10px;" v-if="item1.type === 'video'">
                      <div style="position:relative">
                        <video height="60" controls>
                          <source :src="item1.url" type="video/mp4" />
                        </video>
                        <span style="position:absolute;top:0;right:0;z-index: 100;">
                          <span @click="colse(item1)"><i class="el-icon-error" style="color:#ccc;font-size:16px;"></i></span>
                        </span>
                        <div v-if="showButton === index1" style="position: absolute;width: 100%;height: 60px; background-color: rgba(0, 0, 0, 0.5); z-index: 99; top:0;left:0">
                          <div style="width: 16px;height: 16px; position: absolute;top: 50%;left: 50%;margin-top: -8px;margin-left: -8px;">
                            <i class="el-icon-rank" style="color: #fff;font-size: 16px;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </draggable>
              </el-form>
            </div>
            <div class="demo-drawer__footer" style="text-align:right;margin-top: 20px;">
              <el-button type="primary" size="small" v-if="($store.state.user.schoolInfo.authorize && stu_authorizer_openid) || stu_openid" @click="submitAll" style="margin-left: 10px;">点评并推送</el-button>
              <el-button type="primary" size="small" v-else @click="submitAll('notPush')" style="margin-left: 10px;">点评</el-button>
            </div>
          </div>
        </div>
        <div v-if="isShowCommonPhrases" style="width:1px;height: calc(100vh - 48px); background: #f2f2f2;float: left;margin-left: 5px; margin-right: 5px;"></div>
        <div v-if="isShowCommonPhrases" style="width: calc(100% - 100% / 1.75 - 12px);float: left; ">
          <div v-if="isShowCommonPhrases1" style="height: calc(100vh - 48px); overflow-y: auto; position: relative;">
            <div style="margin-left: 20px;">
              <div style="overflow: hidden;">
                <div class="fl" style="font-size: 16px; margin-bottom: 10px;font-weight:bold">
                  常用语
                </div>
                <div @click="isShowCommonPhrases = false" class="fr" style="font-size: 16px; margin-bottom: 10px;font-weight:bold ;cursor: pointer;">
                  <i class="el-icon-close"></i>
                </div>
              </div>
              <div v-if="tagList.length === 0">
                <el-empty description="暂无评语"></el-empty>
              </div>
              <div v-else @click="SetComment(item.remark)" v-for="(item, index) in tagList" :key="index" style="cursor: pointer;padding: 3px;margin-bottom: 10px;border-bottom:1px solid #f2f2f2;padding-bottom: 10px;">
                <div style="overflow: hidden; ">
                  <div class="txttag" style="width:100%">
                    <span style="word-break: break-all;">{{
                      item.remark
                    }}</span>
                    <span class="BtnShow" style="margin-right: 10px; text-align: right; " @click.stop="editremark(item)">
                      <el-button type="text" size="mini">编辑</el-button>
                    </span>
                    <span class="BtnShow" style="margin-right: 10px; text-align: right; " @click.stop="delremark(item)">
                      <el-button type="text" size="mini">删除</el-button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div style="position:fixed;right:2%;bottom:4%" @click="addremark">
              <div style="width:60px;height: 60px;border-radius: 50%;background-color:#6190F6;">
                <div style="cursor: pointer;position:absolute;width:16px;height:16px;color:#fff;font-size:16px;top:50%;left:50%;margin-top:-8px;margin-left:-8px" class="el-icon-plus"></div>
              </div>
            </div>
          </div>
          <div v-else style="height: calc(100vh - 48px); overflow-y: auto; position: relative;">
            <el-page-header @back="goBack1" content="常用语"> </el-page-header>
            <div style="margin-top:20px;margin-left: 20px;">
              <el-input :autosize="{ minRows: 4, maxRows: 10 }" type="textarea" placeholder="请输入常用语" v-model="remark">
              </el-input>
              <div style="margin-top:20px;overflow:hidden">
                <!-- <el-button @click="dialogVisible5 = false">取 消</el-button> -->
                <el-button style="float:right" type="primary" @click="sumbit5" size="mini">保 存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer title="评论详情" :visible.sync="drawer" size="582px" :with-header="false">
      <el-empty v-if="stuDetails.length == 0" description="暂无评论"></el-empty>

      <div style="padding: 20px; position: relative;" v-for="item in stuDetails" :key="item.id">
        <div style="overflow: hidden; border-bottom: 5px solid #f2f7fd;padding-bottom: 20px;">
          <div :class="{evaInfo:evaZanMap[item.id] && evaZanMap[item.id].zanNum>0}">
            <div class="fl" style="width: 25px;height: 25px; margin-top:30px; border-radius: 50%;overflow: hidden;border: 1px solid #eeebeb; ">
              <img :src="item.userInfo.headImg" style="width: 100%;height: 100%;" />
            </div>
            <div class="fl" style="line-height: 25px;margin-left: 10px;width: calc(100% - 40px);">
              <div style="margin-top:30px;font-weight: bold;">
                指导老师：{{ item.userInfo.realname }}
              </div>
              <template v-for="(item3, index3) in item.score">
                <div style="overflow: hidden;" :key="item3.title+'_'+index3" v-if="item3.star>0">
                  <div class="fl" style="line-height: 20px;font-weight: bold;">
                    {{ item3.title }}：
                  </div>
                  <div class="fl">
                    <el-rate style="height: 20px" class="pd" v-model="item3.star" disabled></el-rate>
                  </div>
                </div>
              </template>

              <div style="margin-top:10px; border-radius:10px;border:1px dashed rgb(209, 189, 107);background:#fdf5da">
                <mavon-editor :style="{ 'min-height': '0px','padding-top':'10px' }" preview-background="#fdf5da" v-model="item.remark" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>

              <div v-for="(item1, index1) in item.attachment" :key="item1.url+'_'+index1">
                <div v-if="item1.type === 'voice'" style="width: 100%;display: block;">
                  <audio class="audioStyle" width="222" height="40" controls>
                    <source :src="item1.url" type="audio/ogg" />
                  </audio>
                </div>
              </div>
              <div v-for="(item1, index1) in item.attachment" :key="index1" style="display:inline-block;">
                <div style="display: inline-block; float: left; margin-right: 10px;margin-top: 10px;" v-if="item1.type === 'img'">
                  <img :src="item1.url" style="width: 100%;height: 60px;" />
                </div>
                <div style="display: inline-block; float: left;  margin-right: 10px;margin-top: 10px;" v-if="item1.type === 'video'">
                  <video height="60" controls>
                    <source :src="item1.url" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
          <div class="evaZanInfo" v-if="evaZanMap[item.id] && evaZanMap[item.id].zanNum>0">
            <div class="zan-num">
              <svg t="1732254799085" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3998" width="16" height="15">
                <path d="M667.786667 117.333333C832.864 117.333333 938.666667 249.706667 938.666667 427.861333c0 138.250667-125.098667 290.506667-371.573334 461.589334a96.768 96.768 0 0 1-110.186666 0C210.432 718.368 85.333333 566.112 85.333333 427.861333 85.333333 249.706667 191.136 117.333333 356.213333 117.333333c59.616 0 100.053333 20.832 155.786667 68.096C567.744 138.176 608.170667 117.333333 667.786667 117.333333z" fill="#F65065" p-id="3999"></path>
              </svg>
              {{evaZanMap[item.id].zanNum}}
            </div>
            <ul>
              <li v-for="(zanItemImg,zanIndex) in evaZanMap[item.id].headImgUrlList" :key="zanIndex">
                <img :src="zanItemImg" alt="">
              </li>
              <li class="more-zan" @click="getMoreZanList(item.id)" v-if="evaZanMap[item.id].headImgUrlList.length<evaZanMap[item.id].zanNum">更多...</li>
            </ul>
          </div>
        </div>
        <div style="position: absolute;left: 20px;top: 20px;cursor: pointer;font-size: 14px;font-weight: bold;">
          {{ item.created_time }}
          <span style="color:green;" v-if="item.is_read">【已读】</span>
          <span style="color:red;" v-else>【未读】</span>
        </div>

        <div style="position: absolute;right: 10px;top: 20px;cursor: pointer;" v-if="$store.state.user.userInfo.id == item.user_id ? true : false">
          <span @click="CreatBill1(item)"><i class="el-icon-share"></i> 海报</span>
          <span @click="sendStuTchPlanEvaluateTemplateMessage(item)" style="margin-left: 10px;" v-if="($store.state.user.schoolInfo.authorize && stu_authorizer_openid) || stu_openid"><i class="el-icon-position"></i> 推送</span>
          <span @click="edit(item)" style="margin-left: 10px;"><i class="el-icon-edit"></i> 编辑</span>
          <span style="margin-left: 10px;" @click="del(item)"><i class="el-icon-delete"></i> 删除</span>
        </div>
      </div>
    </el-drawer>
    <el-drawer title="查看作品 (点击右上角X号退出)" size="100%" :visible.sync="drawer3" :direction="direction" :destroy-on-close="true">
      <iframe id="iframe_project1" width="100%" height="100%" :src="project_url"></iframe>
    </el-drawer>
    <el-dialog title="作品海报" :visible.sync="dialogVisible2" width="500px" top="5vh">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <el-image id="myCanvas" :src="posterImg" fit="fill" style="box-shadow: 0 0 4px 0 #d1d1d1"></el-image>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form size="mini" ref="form" :model="form_share" label-position="top">
              <el-form-item label="样式">
                <el-select style="width: 100px" v-model="form_share.type" placeholder="选择样式" @change="ChangeShareType">
                  <el-option label="样式一" value="1"></el-option>
                  <el-option label="样式二" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="颜色">
                <el-select style="width: 100px" v-model="form_share.color" placeholder="选择颜色" @change="ChangeShareColor">
                  <el-option label="蓝色" value="1"></el-option>
                  <el-option label="绿色" value="2"></el-option>
                  <el-option label="品红" value="3"></el-option>
                  <el-option label="红色" value="4"></el-option>
                  <el-option label="黄色" value="5"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="CreateShareImg" :loading="share_loading">生成海报</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!--分享海报页面-->
    <div id="posterHtml" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: '0px',
        width: '1242px',
        height: schoolLogoUrl ? '2458px' : '2208px',
        border: `1px solid ${imgColorMap[form_share.color]}`,
      }">
      <div style="position: relative; top: 740px; text-align: center">
        <span style="font-weight: bold; color: white; font-size: 80px">{{
          form_share.title
        }}</span><br />
        <span style="color: white; font-size: 50px">{{
          '作者:' + form_share.name
        }}</span>
      </div>

      <el-image style="margin-top: 765px; left: 180px; width: 902px; height: 665px" :src="form_share.cover" fit="fill">
      </el-image>

      <div id="qrcodeWorkImg" style="margin-left: 780px; margin-top: 108px"></div>
      <div class="school-logo" v-if="schoolLogoUrl" :style="{boxSizing:'content-box',position:'absolute',bottom:0,left:0,display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'202px',padding:'25px 0',backgroundColor:imgColorMap[form_share.color]}">
        <img :src="schoolLogoUrl" alt="" style="height:100%" />
      </div>
    </div>
    <!-- 分享海报页面结尾 -->
    <div id="posterHtml1" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: '0px',
        width: '1242px',
        height: schoolLogoUrl ? '2458px' : '2208px',
        border: `1px solid ${imgColorMap[form_share.color]}`,
      }">
      <el-image style="margin-top: 618px; left: 122px; width: 1004px; height: 753px" :src="form_share.cover" fit="fill">
      </el-image>

      <div style="position: relative; top: 10px; text-align: center">
        <span style="font-weight: bold; color: #333333; font-size: 60px">{{
          form_share.title
        }}</span><br />
        <span style="color: #333333; font-size: 40px">{{
          '作者:' + form_share.name
        }}</span>
      </div>

      <div style="margin-left: 230px; margin-top: 33px; color: #f7ba2a">
        <i v-for="count in form_share.star_num" :key="count" class="el-icon-star-on" style="font-size: 100px; margin: 10px">
        </i>
      </div>
      <div v-if="form_share.star_num" id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 212px"></div>
      <div v-else id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 365px"></div>
      <div class="school-logo" v-if="schoolLogoUrl" :style="{boxSizing:'content-box',position:'absolute',bottom:0,left:0,display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'202px',padding:'25px 0',backgroundColor:imgColorMap[form_share.color]}">
        <img :src="schoolLogoUrl" alt="" style="height:100%" />
      </div>
      <!-- <div id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 212px"></div> -->
      <!-- <div id="qrcodeWorkImg1" style="margin-left: 135px; "></div> -->
    </div>

    <el-dialog title="课后点评分享" :visible.sync="dialogVisible3" width="563px" top="5vh">
      <div style="height: 60vh; overflow-y: auto; overflow-x: hidden; ">
        <el-row :gutter="20">
          <el-col :span="17">
            <div>将海报直接分享给家长微信或者转发至朋友圈</div>
            <div style="margin-top:10px;">
              <el-image id="myCanvas" :src="posterImg1" fit="fill"></el-image>
            </div>
          </el-col>
          <el-col :span="7">
            <div>下载二维码结合其他物料进行宣传</div>
            <div style="margin-top: 10px; width: 120px;height: 120px;border: 1px solid #ccc;border-radius: 5px;overflow: hidden;">
              <div id="qrcode" style="width: 120px;height: 120px;"></div>
            </div>
            <div style="margin-top: 10px;" v-if="DownloadImageShow">
              <el-button type="primary" plain @click="DownloadImage2" size="mini">☝ 下载二维码</el-button>
            </div>

            <div style="margin-top: 10px;" v-if="DownloadImageShow">
              <el-button type="primary" plain @click="DownloadImage1" size="mini">👈 下载点评海报</el-button>
            </div>
            <!-- <div style="margin-top: 10px;">
                        <el-button type="primary" @click="CreateShareImg1" :loading="share_loading"
                            size="mini">生成海报</el-button>
                    </div> -->
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <div id="posterHtml2" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        position: 'absolute',
        top: '0px',
        width: '750px',
        height: '1334px',
      }">
      <div style="position: relative; top: 380px; text-align: center">
        <span style="color: #333333; font-size: 40px">{{
          '作者:' + this.stuName
        }}</span>
      </div>

      <div id="qrcodeWorkImg2" style="margin-left: 485px; margin-top: 595px;width: 201px;height: 201px;overflow: hidden;border-radius: 5px;"></div>
      <div class="school-logo" v-if="schoolLogoUrl" :style="{boxSizing:'content-box',position:'absolute',bottom:'20px',right:'30px',display:'flex',justifyContent:'flex-end',width:'380px', height:'130px'}">
        <img :src="schoolLogoUrl" alt="" style="width:auto;object-fit:contain;" />
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStuTchPlanListForEvaluate,
  tchGetStuLessonTchWorkList,
  createOrUpdateStuTchPlanEvaluate,
  getStuTchPlanEvaluateList,
  deleteStuTchPlanEvaluate,
  sendTchWorkTchCommentTemplateMessage,
  sendStuTchPlanEvaluateTemplateMessage,
  getPrepareCurrculumMaterial,
  getTchWorkOfStuTchPlan,
  getGhatGptToken,
} from '@/api/educational.js'
import {
  tchWorkSelfRemarkCreateOrUpdate,
  tchWorkSelfRemarkGet,
  tchWorkSelfRemarkDelete,
} from '@/api/classroom/teacher_api'
import {
  api_schoolStarGrantLectureWorkGrant,
  api_schoolStarGrantCheck,
  api_schoolStarGrantDelete,
  api_stuTchPlanEvaGetEvaZanList,
  api_stuTchPlanEvaUpdateShareReportType,
} from '@/api/javaApi'
import AudioRecorder from 'js-audio-recorder'
import uploadFileBlob2 from '@/config/uploadFileBlob2'
import moment from 'moment'
import uploadFile from '@/config/uploadFileSchool1'
import { tchSaveTchWorkScore } from '@/api/classroom/teacher_api'
import html2canvas from 'html2canvas'
import QRCode from 'qrcodejs2' // 引入qrcode
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  data() {
    return {
      stuName: '',
      tableDataWork: [],
      isShowCommonPhrases: false,
      isShowCommonPhrases1: true,

      widthSize: '40%',
      h5Form: {},
      qrcode: '',
      DownloadImageShow: false,
      //
      dialogVisible3: false,
      form_share1: {
        images1: [
          'https://wugecdn.steam.fun/resources/static/jiaxiaotong/%E6%B5%B7%E6%8A%A53.jpg',
          // 'https://wugecdn.steam.fun/resources/static/jiaxiaotong/%E6%B5%B7%E6%8A%A5.jpeg'
        ],
      },
      posterImg1: '',
      //
      timer: null,
      showButton: -1,
      share_img: '', //默认海报
      imgColorMap: {
        1: '#2EB3FF',
        2: '#35B72A',
        3: '#FF63B1',
        4: '#FF5B5C',
        5: '#FFBD4A',
      },
      share_type: '1', //海报类型
      form_share: {
        subject_id: '2',
        work_id: '',
        type: '1',
        color: '1',
        cover: '',
        title: '',
        name: '',
        star_num: 0,
        images1: [
          'https://wugecdn.steam.fun/resources/static/work_share/bg_blue_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_green_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_pink_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_red_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_1.png',
        ],
        images2: [
          'https://wugecdn.steam.fun/resources/static/work_share/bg_blue_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_green_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_pink_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_red_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_2.png',
        ],
      },
      share_loading: false, //生成海报加载
      posterImg: '',

      dialogVisible2: false,
      drawer1: false,
      workUrl: '',
      isShowForm: true,
      direction: 'ltr',
      project_url: '',
      workInfo: {},
      signList: [
        {
          title: '出勤',
          id: '1',
        },
        {
          title: '缺勤',
          id: '2',
        },
      ],
      scoreList: [
        {
          title: '课堂表现',
          star: '',
          clickCount: 0,
        },
        {
          title: '作业情况',
          star: '',
          clickCount: 0,
        },
        {
          title: '综合评分',
          star: '',
          clickCount: 0,
        },
      ],
      evaluate_id: '',
      stuDetails: [],
      drawer: false,
      train_videoList: [],
      fileList: [],
      fileList1: [],
      stu_tch_plan_id: '',
      url: '',
      countdown: '',
      isShow: false,
      isShow1: true,
      audioUrl: '',
      total1: 0,
      page_size1: 10,
      page_no1: 1,
      CourseworkForm1: {},
      tableData1: [],
      CourseworkForm: {},
      isRecording: false,
      recordedAudio: null,
      mediaRecorder: null,
      chunks: [],
      remark_id: '',
      tagList: [],
      api_key: '',
      request_info: '',
      streamCache: '',
      remark: '',
      markform: {
        markpoint: '',
        remark: '',
        is_good: false,
        is_only: false,
        grantStarNum: 0,
      }, //作品点评
      dialogFormVisible2: false,
      dialogVisible5: false,
      total: 0,
      page_size: 10,
      page_no: 1,
      tableData: [],
      isactive: 0,
      activeName: 'first',
      recorder: null,
      setTime: 0,
      tableData2: [],
      flag: null,
      minute: 0,
      second: 0,
      time: '00:00',
      stu_name: '',
      work_id: '',
      drawer3: false,
      work_title: '',
      tch_work_id: '',
      is_send_tch_comment_wx_message: '',
      schoolId: '',
      evaluateId: '',
      tchPlanId: '',
      stuTchPlanId: '',
      attachment: [],
      url1: '',
      shortUrl: '',
      educational_institution_id: '',
      teaching_plan_id: '',
      stu_tch_plan_id1: '',
      urlId: '',
      stu_authorizer_openid: '',
      stu_openid: '',
      showGrant: false,
      starNumLimit: 0,
      stuInfo: null,
      schoolLogoUrl: '',
      stuTchPlanIdTest: '',
      schoolIdTest: '',
      evaIdList: [],
      evaZanMap: {},
    }
  },
  watch: {
    isShowCommonPhrases(val) {
      if (val === false) {
        this.widthSize = '40%'
      } else {
        this.widthSize = '70%'
      }
    },
    dialogFormVisible2(val) {
      if (val === false) {
        this.isShowCommonPhrases = false
      }
    },
    drawer1(val) {
      console.log(val, 12456)
      if (val === false) {
        this.widthSize = '40%'
        this.isShowCommonPhrases = false
        this.isShow = false
        this.isShow1 = true
        window.clearInterval(this.flag)
        this.minute = 0
        this.second = 0
        this.time = '00:00'
        clearTimeout(this.timer)
      }
    },
    dialogVisible3(val) {
      if (val === false) {
        this.url1 = ''
        this.DownloadImageShow = false
        this.qrcode = ''
      }
    },
  },
  computed: {},

  mounted() {
    this.getStuTchPlanListForEvaluate(true)
    // this.tchGetStuLessonTchWorkList()
    this.workInfo = JSON.parse(sessionStorage.getItem('workInfo'))
    const schoolInfo = JSON.parse(sessionStorage.getItem('schoolInfo'))
    if (schoolInfo) {
      this.schoolLogoUrl = schoolInfo.homepageData.homepage.logo_img_url
    }
  },
  beforeDestroy() { },
  methods: {
    // 获取评论赞数信息
    getStuTchPlanEvaGetEvaZanList(evaIdList) {
      api_stuTchPlanEvaGetEvaZanList({ idList: evaIdList, limit: 10 }).then(res => {
        this.evaZanMap = res;
        Object.values(this.evaZanMap).forEach(obj => { obj.index = 0 })
      })
    },
    // 为某个评论信息获取更多点赞头像
    getMoreZanList(evaId) {
      this.evaZanMap[evaId].index += 1;
      const limit = 10 + this.evaZanMap[evaId].index * 11
      api_stuTchPlanEvaGetEvaZanList({ idList: [evaId], limit }).then(res => {
        console.log(res)
        this.evaZanMap[evaId] = Object.assign(this.evaZanMap[evaId], res[evaId]);
      })
    },
    //动态获得GPT-TOKEN
    getGhatGptToken() {
      getGhatGptToken().then((res) => {
        console.log('动态获取GPT')
        console.log(res.chatGptKeyList)
        localStorage.setItem('gpt_token', res.chatGptKeyList[0].key)
      })
    },

    handleClose2() {
      this.dialogFormVisible2 = false
    },
    handleClose1() {
      this.drawer1 = false
    },
    DownloadImage2() {
      const vm = this

      const domObj = document.getElementById('qrcode')
      console.log('分享海报-样式一')
      console.log(domObj)
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector('#qrcode')
          e.style.display = 'block'
        },
      }).then((canvas) => {
        // 在微信里,可长按保存或转发
        vm.qrcode = canvas.toDataURL('image/png')
        // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
        if (window.navigator.msSaveOrOpenBlob) {
          const bstr = atob(vm.qrcode.split(',')[1])
          let n = bstr.length
          const u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          const blob = new Blob([u8arr])
          window.navigator.msSaveOrOpenBlob(
            blob,
            // 'chart-download' + '.' + 'png'
            `${this.workInfo.lessonTitle}-${this.stuName}.png`
          )
        } else {
          // 这里就按照chrome等新版浏览器来处理
          const a = document.createElement('a')
          a.href = vm.qrcode
          a.setAttribute('download', `${this.workInfo.lessonTitle}-${this.stuName}`)
          a.click()
        }
        // console.log(vm.posterImg1, 123456);
        // console.log("生成的海报");
        // console.log(canvas);
        // console.log(vm.posterImg1);
        // vm.share_loading = false;
        // vm.DownloadImageShow = true;
        // vm.$confirm("海报已生成,是否下载?", "提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "success",
        // }).then(() => {
        //     vm.DownloadImage1();
        // });
      })
    },
    //课程海报
    CreatBill1(row) {
      this.h5Form = row;
      this.urlId = row.id
      this.educational_institution_id = row.educational_institution_id
      this.teaching_plan_id = row.teaching_plan_id
      this.stu_tch_plan_id1 = row.stu_tch_plan_id

      this.stuTchPlanIdTest = row.stu_tch_plan_id;
      this.schoolIdTest = row.educational_institution_id
      console.log(row, 123465489)
      console.log(this.url1, 123415)
      console.log('生成海报')
      // console.log(row, 123456);
      this.dialogVisible3 = true
      this.posterImg1 = this.form_share1.images1[0]
      this.qrcode_work2()
      this.share_img = this.posterImg1
      this.$nextTick(() => {
        this.CreateShareImg1()
      })
    },
    // convertToShortUrl() {
    //     // 使用 Bitly API 将长链接转化为短链接
    //     const accessToken = '4bb100fcd041b75eb3d014f6e74fe6f4f81fd3ab';
    //     const apiUrl = `https://api-ssl.bitly.com/v4/shorten`;
    //     fetch(apiUrl, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': `Bearer ${accessToken}`
    //         },
    //         body: JSON.stringify({
    //             long_url: this.url1
    //         })
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             console.log(data, 123456222);

    //             // 从 API 响应中获取短链接
    //             this.shortUrl = data.link;
    //             console.log(this.shortUrl, 123456222);
    //         })
    //         .catch(error => {
    //             console.error('Error:', error);
    //         });
    // },
    qrcode_work2() {
      document.getElementById('qrcodeWorkImg2').innerHTML = ''
      new QRCode('qrcodeWorkImg2', {
        width: 190,
        height: 190,
        text:
          // process.env.VUE_APP_BASE_URL + '/homeSchoolConnection?evaluateId=' +
          // evaluateId +
          // '&schoolId=' +
          // schoolId +
          // '&tchPlanId=' +
          // tchPlanId +
          // '&stuTchPlanId=' +
          // stuTchPlanId,
          `${process.env.VUE_APP_BASE_URL}/learningReport/index.html?stuTchPlanEvaId=${this.h5Form.id}&eduId=${this.h5Form.educational_institution_id}&eduCampusId=${this.h5Form.educational_institution_campus_id}&tchPlanId=${this.h5Form.teaching_plan_id}&stuTchPlanId=${this.h5Form.stu_tch_plan_id}`,

        colorDark: '#000',
        colorLight: '#fff',
        borderRadius: '5px',
      })
    },
    CreateShareImg1() {
      this.share_loading = true
      document.getElementById('qrcode').innerHTML = ''
      this.posterImg1 = '';
      // 生成海报
      const vm = this
      vm.url1 = ''
      vm.url1 =
        // process.env.VUE_APP_BASE_URL + '/homeSchoolConnection?evaluateId=' +
        // vm.urlId +
        // '&schoolId=' +
        // vm.educational_institution_id +
        // '&tchPlanId=' +
        // vm.teaching_plan_id +
        // '&stuTchPlanId=' +
        // vm.stu_tch_plan_id1
        `${process.env.VUE_APP_BASE_URL}/learningReport/index.html?stuTchPlanEvaId=${this.h5Form.id}&eduId=${this.h5Form.educational_institution_id}&eduCampusId=${this.h5Form.educational_institution_campus_id}&tchPlanId=${this.h5Form.teaching_plan_id}&stuTchPlanId=${this.h5Form.stu_tch_plan_id}`
      let qrcode = new QRCode('qrcode', {
        width: 120, // 设置宽度，单位像素
        height: 120, // 设置高度，单位像素
        text: vm.url1, // 设置二维码内容或跳转地址,
      })
      console.log(qrcode)
      // vm.convertToShortUrl()

      const domObj = document.getElementById('posterHtml2')
      console.log('分享海报-样式一')
      console.log(domObj)
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector('#posterHtml2')
          e.style.display = 'block'
        },
      }).then(function (canvas) {
        // 在微信里,可长按保存或转发
        vm.posterImg1 = canvas.toDataURL('image/png')
        // console.log(vm.posterImg1, 123456);
        console.log('生成的海报')
        console.log(canvas)
        console.log(vm.posterImg1)
        vm.share_loading = false
        vm.DownloadImageShow = true
        // vm.$confirm("海报已生成,是否下载?", "提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "success",
        // }).then(() => {
        //     vm.DownloadImage1();
        // });
      })
    },
    DownloadImage1() {
      console.log('下载分享海报')
      // console.log(this.posterImg1);

      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
      if (window.navigator.msSaveOrOpenBlob) {
        const bstr = atob(this.posterImg1.split(',')[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        const blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, `${this.workInfo.lessonTitle}-${this.stuName}.png`)
      } else {
        // 这里就按照chrome等新版浏览器来处理
        const a = document.createElement('a')
        a.href = this.posterImg1
        a.setAttribute('download', `${this.workInfo.lessonTitle}-${this.stuName}`)
        a.click()
      }
    },
    showButton1(val) {
      this.showButton = val
    },
    hideButton(val) {
      console.log(val)
      this.showButton = -1
    },
    change(event) {
      console.log('change')
      console.log(event)
      console.log(this.attachment)
    },
    start(event) {
      console.log('start')
      console.log(event)
      console.log(this.attachment)
    },
    end(event) {
      console.log('end')
      // event.item  拖拽的本身
      // event.to      拖拽的目标列表
      // event.from    拖拽之前的列表
      // event.oldIndex    拖拽前的位置
      // event.newIndex    拖拽后的位置
      console.log(event)
      console.log(this.attachment)
    },
    // 海报
    compileStr(code) {
      //对字符串进行加密
      var c = String.fromCharCode(code.charCodeAt(0) + code.length)
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
      }
      return escape(c)
    },
    DownloadImage() {
      console.log('下载分享海报')
      // console.log(this.posterImg);

      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
      if (window.navigator.msSaveOrOpenBlob) {
        const bstr = atob(this.posterImg.split(',')[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        const blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, `${this.form_share.title}-${this.form_share.name}.png`)
      } else {
        // 这里就按照chrome等新版浏览器来处理
        const a = document.createElement('a')
        a.href = this.posterImg
        a.setAttribute('download', `${this.form_share.title}-${this.form_share.name}`)
        a.click()
      }
    },

    CreateShareImg() {
      this.share_loading = true
      // 生成海报
      const vm = this

      if (this.form_share.type == '1') {
        const domObj = document.getElementById('posterHtml')
        console.log('分享海报-样式一')
        console.log(domObj)
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          backgroundColor: null,
          onclone(doc) {
            let e = doc.querySelector('#posterHtml')
            e.style.display = 'block'
          },
        }).then(function (canvas) {
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL('image/png')
          console.log('生成的海报')
          console.log(canvas)
          console.log(vm.posterImg)
          vm.share_loading = false
          vm.$confirm('海报已生成,是否下载?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success',
          }).then(() => {
            vm.DownloadImage()
          })
        })
      } else if (this.form_share.type == '2') {
        const domObj = document.getElementById('posterHtml1')
        console.log('分享海报-样式二')
        console.log(domObj)
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          backgroundColor: null,
          onclone(doc) {
            let e = doc.querySelector('#posterHtml1')
            e.style.display = 'block'
          },
        }).then(function (canvas) {
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL('image/png')
          console.log('生成的海报')
          console.log(canvas)
          console.log(vm.posterImg)
          vm.share_loading = false
          vm.$confirm('海报已生成,是否下载?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success',
          }).then(() => {
            vm.DownloadImage()
          })
        })
      }
    },

    ChangeShareColor() {
      console.log('更换海报颜色')
      console.log(this.form_share.color)

      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }
      }

      this.share_img = this.posterImg
    },
    ChangeShareType() {
      console.log('更换海报样式')
      console.log(this.form_share.type)
      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }

        if (this.form_share.subject_id == '1') {
          this.qrcode_work_jr(this.work_url)
        } else if (this.form_share.subject_id == '2') {
          this.qrcode_work()
        }
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }
        if (this.form_share.subject_id == '1') {
          this.qrcode_work_jr1(this.work_url)
        } else if (this.form_share.subject_id == '2') {
          this.qrcode_work1()
        }
      }

      this.share_img = this.posterImg
    },

    CreatBill(row) {
      console.log('生成海报')
      // console.log(row, 123456);
      this.dialogVisible2 = true
      this.form_share.cover = row.covers
      this.form_share.work_id = row.id
      this.form_share.title = row.title
      this.form_share.name = row.name
      this.form_share.star_num = row.markpoint
      this.form_share.subject_id = this.workInfo.subjectCode
      this.work_url = row.work_url
      this.schoolId = row.educational_institution_id
      this.evaluateId = row.id
      this.tchPlanId = row.teaching_plan_id
      this.stuTchPlanId = row.stu_tch_plan_id
      this.stuTchPlanIdTest = row.stu_tch_plan_id;
      this.schoolIdTest = row.educational_institution_id

      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }
        if (this.form_share.subject_id == '1') {
          this.qrcode_work_jr(this.work_url)
        } else if (this.form_share.subject_id == '2') {
          this.qrcode_work()
        }
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }
        if (this.form_share.subject_id == '1') {
          console.log('Jrcode海报2')
          this.qrcode_work_jr1(row.work_url)
        } else if (this.form_share.subject_id == '2') {
          console.log('Scratch海报')
          this.qrcode_work1()
        }
      }

      this.share_img = this.posterImg
    },
    qrcode_work_jr(work_url) {
      document.getElementById('qrcodeWorkImg').innerHTML = ''
      new QRCode('qrcodeWorkImg', {
        width: 365,
        height: 365,
        text:
          'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' + work_url,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: 3,
      })
    },
    qrcode_work_jr1(work_url) {
      console.log('Jrcode 作品地址1')
      console.log(work_url)

      document.getElementById('qrcodeWorkImg1').innerHTML = ''
      new QRCode('qrcodeWorkImg1', {
        width: 240,
        height: 240,
        text:
          'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' + work_url,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: 3,
      })
    },
    // 1
    qrcode_work() {
      document.getElementById('qrcodeWorkImg').innerHTML = ''
      new QRCode('qrcodeWorkImg', {
        width: 365,
        height: 365,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
          this.form_share.work_id +
          '&subject_code=2' + `&stuTchPlanIdTest=${this.stuTchPlanIdTest}&schoolIdTest=${this.schoolIdTest}`, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    qrcode_work1() {
      document.getElementById('qrcodeWorkImg1').innerHTML = ''
      new QRCode('qrcodeWorkImg1', {
        width: 240,
        height: 240,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
          this.form_share.work_id +
          '&subject_code=2' + `&stuTchPlanIdTest=${this.stuTchPlanIdTest}&schoolIdTest=${this.schoolIdTest}`, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    //
    async submitAll() {
      if (this.evaluate_id == '') {
        createOrUpdateStuTchPlanEvaluate({
          stu_tch_plan_id: this.stu_tch_plan_id,
          score: JSON.stringify(this.scoreList),
          evaluate_id: '',
          attachment: JSON.stringify(this.attachment),
          remark: this.markform.remark,
        }).then(async (res) => {
          console.log(res, 12346)
          this.$message.success('已点评')
          // 点评更新
          api_stuTchPlanEvaUpdateShareReportType({ id: res.returnData.id })
          if (this.showGrant) {
            // 可以发放星币
            await api_schoolStarGrantLectureWorkGrant({
              stuId: this.stuInfo.student_user_id,
              eduCampusId: this.stuInfo.educational_institution_campus_id,
              starNum: this.markform.grantStarNum,
              tchPlanId: this.stuInfo.teaching_plan_id,
              commentId: res.returnData.id,
            })
          }
          this.$nextTick(() => {
            var to_url = ''
            if (this.$store.state.user.schoolInfo.authorize) {
              if (this.stu_authorizer_openid) {
                to_url =
                  // process.env.VUE_APP_BASE_URL + '/homeSchoolConnection?evaluateId=' +
                  // res.returnData.id +
                  // '&schoolId=' +
                  // res.returnData.educational_institution_id +
                  // '&tchPlanId=' +
                  // res.returnData.teaching_plan_id +
                  // '&stuTchPlanId=' +
                  // res.returnData.stu_tch_plan_id
                  `${process.env.VUE_APP_BASE_URL}/learningReport/index.html?stuTchPlanEvaId=${res.returnData.id}&eduId=${res.returnData.educational_institution_id}&eduCampusId=${res.returnData.educational_institution_campus_id}&tchPlanId=${res.returnData.teaching_plan_id}&stuTchPlanId=${res.returnData.stu_tch_plan_id}`
                sendStuTchPlanEvaluateTemplateMessage({
                  evaluateId: res.returnData.id,
                  to_url: to_url,
                })
                console.log(to_url, 15448456)
                this.$message({
                  type: 'success',
                  message: '已推送',
                })
              } else {
                // this.$message.warning('已点评，未绑定微信，推送失败')
              }
            } else {
              if (this.stu_openid) {
                to_url =
                  // process.env.VUE_APP_BASE_URL + '/homeSchoolConnection?evaluateId=' +
                  // res.returnData.id +
                  // '&schoolId=' +
                  // res.returnData.educational_institution_id +
                  // '&tchPlanId=' +
                  // res.returnData.teaching_plan_id +
                  // '&stuTchPlanId=' +
                  // res.returnData.stu_tch_plan_id
                  `${process.env.VUE_APP_BASE_URL}/learningReport/index.html?stuTchPlanEvaId=${res.returnData.id}&eduId=${res.returnData.educational_institution_id}&eduCampusId=${res.returnData.educational_institution_campus_id}&tchPlanId=${res.returnData.teaching_plan_id}&stuTchPlanId=${res.returnData.stu_tch_plan_id}`
                sendStuTchPlanEvaluateTemplateMessage({
                  evaluateId: res.returnData.id,
                  to_url: to_url,
                })
                this.$message({
                  type: 'success',
                  message: '已推送',
                })
                console.log(to_url, 15448456)
              } else {
                // this.$message.warning('已点评，未绑定微信，推送失败')
              }
            }

            this.getStuTchPlanListForEvaluate()
            this.drawer1 = false
          })
        })
      } else {
        createOrUpdateStuTchPlanEvaluate({
          stu_tch_plan_id: this.stu_tch_plan_id,
          score: JSON.stringify(this.scoreList),
          evaluate_id: this.evaluate_id,
          attachment: JSON.stringify(this.attachment),
          remark: this.markform.remark,
        }).then(async (res) => {
          console.log(res, 12346)
          if (this.showGrant) {
            // 可以发放星币
            await api_schoolStarGrantLectureWorkGrant({
              stuId: this.stuInfo.student_user_id,
              eduCampusId: this.stuInfo.educational_institution_campus_id,
              starNum: this.markform.grantStarNum,
              tchPlanId: this.stuInfo.teaching_plan_id,
              commentId: this.stuInfo.id,
            })
          }
          getStuTchPlanEvaluateList({
            stu_tch_plan_id: this.h5Form.stu_tch_plan_id,
          }).then((res) => {
            // console.log(res, 123456);
            this.stuDetails = res.evaluateList
          })

          var to_url = ''
          if (this.$store.state.user.schoolInfo.authorize) {
            if (this.stu_authorizer_openid) {

              to_url =
                // process.env.VUE_APP_BASE_URL + '/homeSchoolConnection?evaluateId=' +
                // this.h5Form.id +
                // '&schoolId=' +
                // this.h5Form.educational_institution_id +
                // '&tchPlanId=' +
                // this.h5Form.teaching_plan_id +
                // '&stuTchPlanId=' +
                // this.h5Form.stu_tch_plan_id
                `${process.env.VUE_APP_BASE_URL}/learningReport/index.html?stuTchPlanEvaId=${this.h5Form.id}&eduId=${this.h5Form.educational_institution_id}&eduCampusId=${this.h5Form.educational_institution_campus_id}&tchPlanId=${this.h5Form.teaching_plan_id}&stuTchPlanId=${this.h5Form.stu_tch_plan_id}`
              sendStuTchPlanEvaluateTemplateMessage({
                evaluateId: this.h5Form.id,
                to_url: to_url,
              })
              this.$message({
                type: 'success',
                message: '已推送',
              })
            } else {
              this.$message.warning('已点评，未绑定微信，推送失败')
            }
          } else {
            if (this.stu_openid) {
              to_url =
                // process.env.VUE_APP_BASE_URL + '/homeSchoolConnection?evaluateId=' +
                // this.h5Form.id +
                // '&schoolId=' +
                // this.h5Form.educational_institution_id +
                // '&tchPlanId=' +
                // this.h5Form.teaching_plan_id +
                // '&stuTchPlanId=' +
                // this.h5Form.stu_tch_plan_id
                `${process.env.VUE_APP_BASE_URL}/learningReport/index.html?stuTchPlanEvaId=${this.h5Form.id}&eduId=${this.h5Form.educational_institution_id}&eduCampusId=${this.h5Form.educational_institution_campus_id}&tchPlanId=${this.h5Form.teaching_plan_id}&stuTchPlanId=${this.h5Form.stu_tch_plan_id}`
              sendStuTchPlanEvaluateTemplateMessage({
                evaluateId: this.h5Form.id,
                to_url: to_url,
              })
              this.$message({
                type: 'success',
                message: '已推送',
              })
            } else {
              this.$message.warning('已点评，未绑定微信，推送失败')
            }
          }
          // var to_url = "";
          // to_url =
          //     "https://steam.fun/homeSchoolConnection?evaluateId=" +
          //     this.h5Form.id +
          //     "&schoolId=" +
          //     this.h5Form.educational_institution_id +
          //     "&tchPlanId=" +
          //     this.h5Form.teaching_plan_id +
          //     "&stuTchPlanId=" +
          //     this.h5Form.stu_tch_plan_id;
          // sendStuTchPlanEvaluateTemplateMessage({
          //     evaluateId: this.h5Form.id,
          //     to_url: to_url,
          // });
          this.getStuTchPlanListForEvaluate()
          this.drawer1 = false
        })
      }
    },
    sendStuTchPlanEvaluateTemplateMessage(row) {
      this.$confirm('即将把作品推送至家长微信,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log(row, 12345)
          var to_url = ''
          // to_url =
          //     "https://steam.fun/homeSchoolConnection?evaluateId=23&schoolId=36&tchPlanId=687061&stuTchPlanId=4367642";

          //to_url =  'https://steam.fun/homeSchoolConnection?evaluateId=50&schoolId=40&tchPlanId=687335&stuTchPlanId=4368158'
          to_url =
            // process.env.VUE_APP_BASE_URL + '/homeSchoolConnection?evaluateId=' +
            // row.id +
            // '&schoolId=' +
            // row.educational_institution_id +
            // '&tchPlanId=' +
            // row.teaching_plan_id +
            // '&stuTchPlanId=' +
            // row.stu_tch_plan_id
            `${process.env.VUE_APP_BASE_URL}/learningReport/index.html?stuTchPlanEvaId=${row.id}&eduId=${row.educational_institution_id}&eduCampusId=${row.educational_institution_campus_id}&tchPlanId=${row.teaching_plan_id}&stuTchPlanId=${row.stu_tch_plan_id}`
          sendStuTchPlanEvaluateTemplateMessage({
            evaluateId: row.id,
            to_url: to_url,
          }).then((res) => {
            console.log(res)
            getStuTchPlanEvaluateList({
              stu_tch_plan_id: this.stu_tch_plan_id,
            }).then((res) => {
              // console.log(res, 123456);
              this.stuDetails = res.evaluateList
            })
            this.getStuTchPlanListForEvaluate()
            this.$message({
              type: 'success',
              message: '推送成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消推送',
          })
        })
    },
    all(key = '') {
      // this.tchSaveTchWorkScore();
      if (!this.markform.markpoint) {
        this.$message.warning('请对作品等级进行评价!')
        return
      } else {
        tchSaveTchWorkScore({
          subject_code: this.workInfo.subjectCode,
          tch_work_id: this.work_id,
          markpoint: this.markform.markpoint,
          remark: this.markform.remark,
          is_good: this.markform.is_good,
          is_only: this.markform.is_only,
        }).then((res) => {
          console.log('教师点评作品')
          console.log(res)
          if (res.is_update) {
            this.$message.success('点评成功')

            this.dialogFormVisible2 = false
            // this.tchGetStuLessonTchWorkList();
          }
        })
        if (key === 'notPush') return false; // 如果只是点评，就不推送
        var to_url = ''
        var remark = ''
        if (this.workInfo.subjectCode == '1') {
          to_url =
            'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' +
            this.workUrl
          remark = '无'
        } else if (this.workInfo.subjectCode == '2') {
          to_url =
            'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
            this.work_id +
            '&subject_code=2' + `&stuTchPlanIdTest=${this.stuTchPlanIdTest}&schoolIdTest=${this.schoolIdTest}`
          remark = '点击详情,立即体验!'
        } else if (this.workInfo.subjectCode == '3') {
          to_url = ''
          remark = '无'
        }

        sendTchWorkTchCommentTemplateMessage({
          tch_work_id: this.work_id,
          subject_code: this.workInfo.subjectCode,
          to_url: to_url,
          remark: remark,
        }).then((res) => {
          console.log('推送通知')
          console.log(res)
          this.tchGetStuLessonTchWorkList()
          // if (res.is_send) {
          //     console.log("发送成功");
          //     this.$message.success("点评已推送至家长微信");
          //     // this.tchGetTchStuTchWorkList();
          //     this.tchGetStuLessonTchWorkList();
          // } else {
          //     this.$message.warning(res.msg);
          // }
        })
        // this.$confirm("即将把作品推送至家长微信,是否继续?", "提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning",
        // }).then(() => {
        //     if (this.is_send_tch_comment_wx_message) {
        //         this.$confirm("已推送过点评消息,是否再次推送?", "提示", {
        //             confirmButtonText: "确定",
        //             cancelButtonText: "取消",
        //             type: "warning",
        //         }).then(() => {
        //             var to_url = "";
        //             var remark = "";
        //             if (this.workInfo.subjectCode == "1") {
        //                 to_url =
        //                     "https://steam.fun/jrcode/h5show.html?mode=look&filepath=" +
        //                     this.workUrl;
        //                 remark = "无";
        //             } else if (this.workInfo.subjectCode == "2") {
        //                 to_url =
        //                     "https://steam.fun/scratch/h5player.html?work_type=2&work_id=" +
        //                     this.work_id +
        //                     "&subject_code=2";
        //                 remark = "点击详情,立即体验!";
        //             } else if (this.workInfo.subjectCode == "3") {
        //                 to_url = "";
        //                 remark = "无";
        //             }

        //             sendTchWorkTchCommentTemplateMessage({
        //                 tch_work_id: this.work_id,
        //                 subject_code: this.workInfo.subjectCode,
        //                 to_url: to_url,
        //                 remark: remark,
        //             }).then((res) => {
        //                 console.log("推送通知");
        //                 console.log(res);
        //                 if (res.is_send) {
        //                     console.log("发送成功");
        //                     this.$message.success("点评已推送至家长微信");
        //                     // this.tchGetTchStuTchWorkList();
        //                     this.tchGetStuLessonTchWorkList();
        //                 } else {
        //                     this.$message.warning(res.msg);
        //                 }
        //             });
        //         });
        //     } else {
        //         var to_url = "";
        //         var remark = "";
        //         if (this.workInfo.subjectCode == "1") {
        //             to_url =
        //                 "https://steam.fun/jrcode/h5show.html?mode=look&filepath=" +
        //                 this.workUrl;
        //             remark = "无";
        //         } else if (this.workInfo.subjectCode == "2") {
        //             to_url =
        //                 "https://steam.fun/scratch/h5player.html?work_type=2&work_id=" +
        //                 this.work_id +
        //                 "&subject_code=2";
        //             remark = "点击详情,立即体验!";
        //         } else if (this.workInfo.subjectCode == "3") {
        //             to_url = "";
        //             remark = "无";
        //         }

        //         sendTchWorkTchCommentTemplateMessage({
        //             tch_work_id: this.work_id,
        //             subject_code: this.workInfo.subjectCode,
        //             to_url: to_url,
        //             remark: remark,
        //         }).then((res) => {
        //             console.log("推送通知");
        //             console.log(res);
        //             if (res.is_send) {
        //                 console.log("发送成功");
        //                 this.$message.success("点评已推送至家长微信");
        //                 // this.tchGetTchStuTchWorkList();
        //                 this.tchGetStuLessonTchWorkList();
        //             } else {
        //                 this.$message.warning(res.msg);
        //             }
        //         });
        //     }
        // });
      }

      console.log('推送通知')
    },
    sendTchWorkTchCommentTemplateMessage(row) {
      console.log('推送通知')
      console.log(row)

      this.$confirm('即将把作品推送至家长微信,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (row.is_send_tch_comment_wx_message) {
          this.$confirm('已推送过点评消息,是否再次推送?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            var to_url = ''
            var remark = ''
            if (this.workInfo.subjectCode == '1') {
              to_url =
                'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' +
                row.work_url
              remark = '无'
            } else if (this.workInfo.subjectCode == '2') {
              to_url =
                'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
                row.id +
                '&subject_code=2' + `&stuTchPlanIdTest=${this.stuTchPlanIdTest}&schoolIdTest=${this.schoolIdTest}`
              remark = '点击详情,立即体验!'
            } else if (this.workInfo.subjectCode == '3') {
              to_url = ''
              remark = '无'
            }

            sendTchWorkTchCommentTemplateMessage({
              tch_work_id: row.id,
              subject_code: this.workInfo.subjectCode,
              to_url: to_url,
              remark: remark,
            }).then((res) => {
              console.log('推送通知')
              console.log(res)
              if (res.is_send) {
                console.log('发送成功')
                this.$message.success('点评已推送至家长微信')
                this.tchGetStuLessonTchWorkList()
              } else {
                this.$message.warning(res.msg)
              }
            })
          })
        } else {
          var to_url = ''
          var remark = ''
          if (this.workInfo.subjectCode == '1') {
            to_url =
              'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' +
              row.work_url
            remark = '无'
          } else if (this.workInfo.subjectCode == '2') {
            to_url =
              'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
              row.id +
              '&subject_code=2' + `&stuTchPlanIdTest=${this.stuTchPlanIdTest}&schoolIdTest=${this.schoolIdTest}`
            remark = '点击详情,立即体验!'
          } else if (this.workInfo.subjectCode == '3') {
            to_url = ''
            remark = '无'
          }
          sendTchWorkTchCommentTemplateMessage({
            tch_work_id: row.id,
            subject_code: this.workInfo.subjectCode,
            to_url: to_url,
            remark: remark,
          }).then((res) => {
            console.log('推送通知')
            console.log(res)
            if (res.is_send) {
              console.log('发送成功')
              this.$message.success('点评已推送至家长微信')
              this.tchGetStuLessonTchWorkList()
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    goDetails(row) {
      console.log(row, 562323)
      this.cpp_url =
        '/cpp?' +
        '&lesson_id=' +
        this.workInfo.lessonId +
        '&stu_id=' +
        row.stu_user_id +
        '&type=' +
        row.work_type +
        '&userType=' +
        'stu' +
        '&comment=' +
        'tchComment'
      sessionStorage.setItem('lecturesTitle', this.workInfo.lessonTitle)
      sessionStorage.setItem('sbj', '4')

      window.open(this.cpp_url, '_blank')
    },
    LookOneWork1(row) {
      console.log('查看1个作品')
      console.log(row)
      this.work_title = row.title
      this.work_url = row.work_url
      this.workinfo = row
      this.tch_work_id = row.id
      console.log('workinfo')
      console.log(this.workinfo)
      console.log('stuinfo')
      console.log(this.StuInfo)

      if (this.workInfo.subjectCode == '1') {
        this.project_url =
          '/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=' +
          row.work_url +
          '&stu_user_id=' +
          row.stu_user_id +
          '&stu_tch_plan_id=' +
          row.stu_tch_plan_id +
          '&work_type=' +
          row.work_type
        this.drawer3 = true
      } else if (this.workInfo.subjectCode == '2') {
        console.log('SC作品查看')

        //this.dialogFormVisible = true;
        this.project_url =
          '/scratch/teachsc.html?workurl=' +
          this.compileStr(row.work_url).replace(/%/g, '%25') +
          '&workname=' +
          row.title +
          '&stu_user_id=' +
          row.stu_user_id +
          '&stu_tch_plan_id=' +
          row.stu_tch_plan_id +
          '&work_type=' +
          row.work_type +
          '&mode=4'

        console.log('URL')
        console.log(this.project_url)

        this.drawer3 = true
      } else if (this.workInfo.subjectCode == '3') {
        console.log(123, 1111)
        getPrepareCurrculumMaterial({
          currMatId: this.$route.query.lessonId,
          tchPlanId: this.$route.query.teachingPlanId,
        }).then((res) => {
          console.log('上课页面返回的课程信息')
          console.log(res)
          localStorage.setItem(
            'home_template_url',
            res.curriculumMaterial.homeTemplateUrl
          )
        })
        if (localStorage.getItem('current_py_version') == 'v2') {
          this.project_url =
            '/python/teachpy_v2?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type
        } else if (localStorage.getItem('current_py_version') == 'v1') {
          this.project_url =
            '/python/teachpy?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type
        } else {
          this.project_url =
            '/python/teachpy_v2?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type
        }

        this.$store.commit('SET_TEACH_TEMPLATE_URL', row.work_url || '')
        this.drawer3 = true
      }
    },
    LookOneWork(row) {
      console.log('查看1个作品')
      console.log(row)
      this.work_title = row.title
      this.work_url = row.work_url
      this.workinfo = row
      this.tch_work_id = row.id
      if (row.is_marking) {
        this.markform = {
          is_good: row.is_good,
          is_only: row.is_only,
          markpoint: row.markpoint,
          remark: row.remark,
        }
      } else {
        this.markform = {
          is_good: false,
          is_only: false,
          markpoint: '',
          remark: '',
        }
      }

      console.log('workinfo')
      console.log(this.workinfo)
      console.log('stuinfo')
      console.log(this.StuInfo)

      if (this.workInfo.subjectCode == '1') {
        this.project_url =
          '/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=' +
          row.work_url +
          '&stu_user_id=' +
          row.stu_user_id +
          '&stu_tch_plan_id=' +
          row.stu_tch_plan_id +
          '&work_type=' +
          row.work_type
        this.drawer3 = true
      } else if (this.workInfo.subjectCode == '2') {
        console.log('SC作品查看')

        //this.dialogFormVisible = true;
        this.project_url =
          '/scratch/teachsc.html?workurl=' +
          this.compileStr(row.work_url).replace(/%/g, '%25') +
          '&workname=' +
          row.title +
          '&stu_user_id=' +
          row.stu_user_id +
          '&stu_tch_plan_id=' +
          row.stu_tch_plan_id +
          '&work_type=' +
          row.work_type +
          '&mode=4'

        console.log('URL')
        console.log(this.project_url)

        this.drawer3 = true
      } else if (this.workInfo.subjectCode == '3') {
        console.log(123, 1111)
        getPrepareCurrculumMaterial({
          currMatId: this.$route.query.lessonId,
          tchPlanId: this.$route.query.teachingPlanId,
        }).then((res) => {
          console.log('上课页面返回的课程信息')
          console.log(res)
          localStorage.setItem(
            'home_template_url',
            res.curriculumMaterial.homeTemplateUrl
          )
        })
        if (localStorage.getItem('current_py_version') == 'v2') {
          this.project_url =
            '/python/teachpy_v2?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type
        } else if (localStorage.getItem('current_py_version') == 'v1') {
          this.project_url =
            '/python/teachpy?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type
        } else {
          this.project_url =
            '/python/teachpy_v2?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type
        }

        this.$store.commit('SET_TEACH_TEMPLATE_URL', row.work_url || '')
        this.drawer3 = true
      }
    },

    evaluate1(row) {
      this.stu_openid = row.openid
      this.stu_authorizer_openid = row.authorizer_openid
      this.isShowForm = true
      this.is_send_tch_comment_wx_message = row.is_send_tch_comment_wx_message
      console.log(row, 1234659)
      this.stu_name = row.name
      this.work_id = row.id
      this.workUrl = row.work_url
      this.markform.markpoint = row.markpoint
      this.markform.remark = row.remark
      this.markform.is_good = row.is_good
      this.markform.is_only = row.is_only
      this.stuTchPlanIdTest = row.stu_tch_plan_id;
      this.schoolIdTest = row.educational_institution_id
      this.dialogFormVisible2 = true
      this.tchWorkSelfRemarkGet()
    },
    //点评
    tchSaveTchWorkScore() {
      console.log('教师点评作品')
      console.log(this.markform, 123465)
      console.log(this.subject_code)
      console.log(this.tch_work_id)

      if (!this.markform.markpoint) {
        this.$message.warning('请对作品等级进行评价!')
        return
      }

      tchSaveTchWorkScore({
        subject_code: this.workInfo.subjectCode,
        tch_work_id: this.work_id,
        markpoint: this.markform.markpoint,
        remark: this.markform.remark,
        is_good: this.markform.is_good,
        is_only: this.markform.is_only,
      }).then((res) => {
        console.log('教师点评作品')
        console.log(res)
        if (res.is_update) {
          this.$message.success('点评成功')
          this.dialogFormVisible2 = false
          this.tchGetStuLessonTchWorkList()
        }
      })
    },
    //

    //
    colse(val) {
      // console.log(val, 123456);
      this.fileList.splice(this.fileList.indexOf(val), 1)
      this.attachment.splice(this.attachment.indexOf(val), 1)
    },
    //删除
    del(row) {
      console.log(row)
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteStuTchPlanEvaluate({
            evaluate_id: row.id,
          }).then(() => {
            api_schoolStarGrantDelete({
              stuId: row.student_user_id,
              commentId: row.id,
            })
            getStuTchPlanEvaluateList({
              stu_tch_plan_id: this.stu_tch_plan_id,
            }).then((res) => {
              // console.log(res, 123456);
              this.stuDetails = res.evaluateList
            })
            this.getStuTchPlanListForEvaluate()
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    //详情
    detailsComment(row) {
      this.stu_openid = row.stu_openid
      this.stu_authorizer_openid = row.stu_authorizer_openid
      getTchWorkOfStuTchPlan({
        stu_tch_plan_id: row.id,
      }).then((res) => {
        console.log(res, 2134545)
        this.tableDataWork = []
        if (res.stuTchPlanInfo.classWorkInfo != undefined) {
          this.tableDataWork.push(res.stuTchPlanInfo.classWorkInfo)
        }
        if (res.stuTchPlanInfo.homeWorkInfo != undefined) {
          this.tableDataWork.push(res.stuTchPlanInfo.homeWorkInfo)
        }
        console.log(this.tableDataWork, 2134545)
      })
      this.stu_name = row.stu_name
      this.stuName = row.stu_name
      console.log(this.$store.state.user.userInfo.id, 1231456)
      this.stu_tch_plan_id = row.id
      console.log(row, 123465)
      getStuTchPlanEvaluateList({
        stu_tch_plan_id: row.id,
      }).then((res) => {
        // console.log(res, 123456);
        this.evaIdList = [];
        res.evaluateList.forEach(evaItem => {
          this.evaIdList.push(evaItem.id)
        })
        this.stuDetails = res.evaluateList
        this.getStuTchPlanEvaGetEvaZanList(this.evaIdList);
      })
      this.drawer = true
    },
    uploadFile() { },
    handleRemove(file, fileList) {
      console.log(fileList)
      this.train_videoList = []
    },
    handleRemove1(file, fileList) {
      console.log(fileList)
      this.fileList1 = []
    },
    async handleChangeFile1(file, fileList) {
      var FileExt = file.name.replace(/.+\./, '')
      if (['png', 'jpg', 'jpeg'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: 'warning',
          message: '请上传后缀名为png,jpg,jpeg的附件！',
        })
        return false
      } else {
        console.log('知识点海报')
        var status = 'course_learn_videoeurl1'
        if (!this.uploadFileTime) {
          await this.uploadFileOss1(fileList, status)
        }
      }
    },
    async uploadFileOss1(list) {
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log(res, 123456)
          // this.fileList1 = []
          // if (this.attachment.length != 0) {
          //     this.attachment = this.attachment.filter(item => item.type !== 'img');

          // }
          console.log(this.attachment, 123456)
          this.fileList1 = res
          console.log(this.fileList1, 123456)
          this.fileList1.map((item) => {
            this.attachment.push({
              url: item.url,
              size: item.length,
              type: 'img',
            })
          })
          console.log(this.attachment, 123456)
        }
      )
    },
    //师训视频
    async handleChangeFile(file, fileList) {
      var FileExt = file.name.replace(/.+\./, '')
      if (['mp4'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: 'warning',
          message: '请上传后缀名为mp4的附件！',
        })
        return false
      } else {
        console.log('师训视频')
        var status = 'course_train_videourl'
        if (!this.uploadFileTime) {
          await this.uploadFileOss(fileList, status)
        }
      }
    },
    async uploadFileOss(list) {
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.train_videoList = res
          console.log(this.train_videoList, 123456)
          this.train_videoList.map((item) => {
            this.attachment.push({
              url: item.url,
              size: item.length,
              type: 'video',
            })
          })
        }
      )
    },
    edit(val) {
      this.stuInfo = val
      this.markform.grantStarNum = 0
      api_schoolStarGrantCheck({
        stuId: val.student_user_id,
        commentId: val.id,
      }).then((res) => {
        if (res) {
          this.markform.grantStarNum = res.starNum
        }
      })
      this.h5Form = val
      this.tchWorkSelfRemarkGet()

      console.log(val, 123465)
      this.evaluate_id = val.id
      this.markform.markpoint = val.score
      this.markform.remark = val.remark
      this.scoreList = val.score
      this.attachment = []
      this.fileList = []

      if (val.attachment.length != 0) {
        this.attachment = val.attachment
        this.attachment.map((item) => {
          if (item.type === 'voice') {
            this.fileList.push(item)
          }
        })
      }
      // if (val.video.length != 0) {
      //     this.train_videoList = val.video
      // }
      // if (val.image.length != 0) {
      //     this.fileList1 = val.image
      //     console.log(this.fileList1);
      // }
      // if (val.voice.length != 0) {
      //     this.fileList = val.voice
      // }
      this.drawer1 = true
    },
    //点评
    submit() {
      if (this.evaluate_id == '') {
        console.log(123)
        console.log(this.attachment, 123456)
        createOrUpdateStuTchPlanEvaluate({
          stu_tch_plan_id: this.stu_tch_plan_id,
          score: JSON.stringify(this.scoreList),
          evaluate_id: '',
          attachment: JSON.stringify(this.attachment),
          remark: this.markform.remark,
        }).then((res) => {
          console.log(res, 12346)
          this.drawer1 = false

          this.getStuTchPlanListForEvaluate()
          this.$message.success('点评成功')
        })
      } else {
        createOrUpdateStuTchPlanEvaluate({
          stu_tch_plan_id: this.stu_tch_plan_id,
          score: JSON.stringify(this.scoreList),
          evaluate_id: this.evaluate_id,
          attachment: JSON.stringify(this.attachment),
          remark: this.markform.remark,
        }).then((res) => {
          console.log(res, 12346)

          getStuTchPlanEvaluateList({
            stu_tch_plan_id: this.stu_tch_plan_id,
          }).then((res) => {
            console.log(res, 123456)
            this.stuDetails = res.evaluateList
          })
          this.drawer1 = false

          this.getStuTchPlanListForEvaluate()
          this.$message.success('编辑成功')
        })
      }
    },
    //
    isShowTime() {
      console.log(this.fileList)
      console.log(this.attachment)
      if (this.fileList.length === 1) {
        this.$message.warning('最多可上传1条录音')
      } else {
        this.isShow = true
      }
    },
    stopTime() {
      this.isShow = false
    },
    search4() {
      this.page_no1 = 1
      this.getStuTchPlanListForEvaluate()
    },
    getStuTchPlanListForEvaluate(getGrantRule = false) {
      getStuTchPlanListForEvaluate({
        sign_state: this.CourseworkForm1.sign_state,
        evaluateState: this.CourseworkForm1.evaluateState,
        teachingPlanId: this.$route.query.teachingPlanId,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then(async (res) => {
        console.log(res, 123456)
        this.tableData1 = res.stuPlanList
        this.total1 = res.total
        this.markform.grantStarNum = 0
        if (getGrantRule) {
          const ruleRes = await this.$store.dispatch(
            'schoolEduCampusStarRule',
            {
              eduCampusId:
                res.curriculumClassInfo.educational_institution_campus_id,
              ruleType: 3,
            }
          )
          this.showGrant = ruleRes.flag
          this.starNumLimit = ruleRes.starNumLimit
        }
      })
    },

    //点评学员
    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getStuTchPlanListForEvaluate()
    },
    //点评作品
    handleCurrentChange(val) {
      this.page_no = val
      this.tchGetStuLessonTchWorkList()
    },
    search3() {
      this.page_no = 1
      this.tchGetStuLessonTchWorkList()
    },
    tchGetStuLessonTchWorkList() {
      tchGetStuLessonTchWorkList({
        subject_code: this.$route.query.subjectCode,
        teaching_plan_id: this.$route.query.teachingPlanId,
        is_marking: this.CourseworkForm.is_marking,
        work_type: this.CourseworkForm.type,
        title: this.CourseworkForm.title,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData = res.workList
        this.total = res.total
      })
    },
    qx() {
      this.isShow = false
      this.isShow1 = true
      window.clearInterval(this.flag)
      this.minute = 0
      this.second = 0
      this.time = '00:00'
      clearTimeout(this.timer)
    },
    complZero(n) {
      return n < 10 ? '0' + n : '' + n
    },
    startRecording() {
      this.flag = setInterval(() => {
        this.second = this.second + 1
        if (this.second >= 60) {
          this.second = 0
          this.minute = this.minute + 1
        }

        if (this.minute >= 60) {
          this.minute = 0
        }
        this.time =
          this.complZero(this.minute) + ':' + this.complZero(this.second)
      }, 1000)
      this.isShow1 = false
      this.recorder = new AudioRecorder()
      console.log(this.recorder, 132456)
      // this.recorder.start();
      AudioRecorder.getPermission().then(() => {
        this.recorder.start()
      }),
        (error) => {
          this.$message({
            message: '请先允许该网页使用麦克风',
            type: 'info',
          })
          console.log(`${error.name} : ${error.message}`)
        }

      this.timer = setTimeout(() => {
        this.handleStop()
        this.$message.warning('录音时间到')
      }, 180000)
    },
    handleStop() {
      clearTimeout(this.timer)
      window.clearInterval(this.flag)
      this.minute = 0
      this.second = 0
      this.time = '00:00'
      console.log(JSON.parse(JSON.stringify(this.tableData2)), 12.45)
      this.isShow1 = true
      this.isShow = false
      console.log('停止录音')
      this.recorder.stop() // 停止录音
      clearTimeout(this.setTime)
      // this.recorder.duration= 0;
      console.log('时长', this.recorder.duration)
      console.log(this.recorder.getWAV(), 123456)
      console.log(this.recorder.getWAVBlob(), 123456)
      console.log(this.recorder.getChannelData(), 123456)
      const file = new window.File(
        [this.recorder.getWAVBlob()],
        moment().unix() + '.wav',
        { type: 'wav' }
      )
      console.log(file.name, 123456)
      var that = this
      uploadFileBlob2(
        file,
        'static/' + this.$store.state.user.userInfo.code + '/' + file.name,
        function (res) {
          let url1 = ''
          console.log('上传成功')
          console.log(res.url, 12.45)
          url1 = res.url
          console.log(url1, 12.45)
          console.log(that.url, 12.45)
          that.url = res.url
          console.log(that.url, 12.45)
          that.fileList.unshift({
            url: res.url,
            size: Math.ceil(file.size / 1024) + 'KB',
          })
          that.attachment.unshift({
            url: res.url,
            size: Math.ceil(file.size / 1024) + 'KB',
            type: 'voice',
          })
          console.log(that.fileList, 12.45)
        }
      )
    },
    goBack() {
      this.$router.push({
        name: 'works',
      })
    },
    handleClick(val) {
      if (val.name == 'first') {
        this.getStuTchPlanListForEvaluate()
      } else {
        this.tchGetStuLessonTchWorkList()
      }
    },
    onclick(val) {
      this.isactive = val
    },
    handleSelectionChange(val) {
      console.log(val)
    },
    goBack1() {
      this.isShowCommonPhrases1 = true
    },
    addremark() {
      // this.remark = ''
      this.remark_id = ''
      this.remark = ''
      this.isShowCommonPhrases1 = false
      // this.dialogVisible5 = true;
    },
    //设置评语
    SetComment(val) {
      console.log(val)
      this.markform.remark = this.markform.remark + val
    },

    //
    async generate_ai() {
      console.log('新的Ai服务器')
      console.log(this.workInfo)
      console.log(this.stuInfo)

      this.subjectname = ''
      this.request_info = ''

      this.request_info =
        '学员名称:"' +
        this.stu_name + ',性别:' + this.stuInfo.stu_sex +
        '",学习的科目是' +
        this.workInfo.subjectName

      this.streamCache = ''
      this.loading = true

      fetch('https://ai.wugedianxia.cn/api/chat/completions', {
        method: 'POST',
        body: JSON.stringify({
          text: this.request_info,
          //sessionId: 894,
          appId: 58,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('gpt_token'),
        },
      }).then((res) => {
        console.log('新人工智能服务器返回')
        console.log(res)

        const reader = res.body.getReader()
        const decoder = new TextDecoder('utf-8')

        let that = this
        reader.read().then(async function processText(res) {
          //console.log("循环读取信息");
          //console.log(res);

          if (res.done || !that.loading) {
            return
          }

          const decodeContent = decoder.decode(res.value)

          //console.log("decodeContent");
          //console.log(decodeContent);

          // error
          if (decodeContent.includes(`"error": {\n`)) {
            console.log('账户错误')
            console.log(decodeContent)
            that.loading = false
            return
          }

          // done
          if (decodeContent.includes('data: [DONE]')) {
            that.loading = false
            console.log('回答完成')
            return
          }

          decodeContent
            .replaceAll('data: ', '')
            .split('\n')
            .filter(Boolean)
            .forEach(async (item) => {
              const itemObj = JSON.parse(item)

              console.log('新服务器回答')
              console.log(itemObj)

              if (!itemObj.data) {
                return
              }

              const str = itemObj.data

              if (itemObj.type == 'string') {
                that.streamCache += str
                that.markform.remark += str
              }
            })

          return reader.read().then(processText)
        })
      })
    },

    editremark(row) {
      this.remark_id = row.id
      this.remark = row.remark
      this.isShowCommonPhrases1 = false
      // this.dialogVisible5 = true;
    },
    delremark(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchWorkSelfRemarkDelete({
            remark_id: row.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.tchWorkSelfRemarkGet()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    evaluate(row) {
      //动态获取GPT_TOKEN
      this.getGhatGptToken()

      this.stuInfo = row
      this.stu_openid = row.stu_openid
      this.stu_authorizer_openid = row.stu_authorizer_openid
      this.stuTchPlanIdTest = row.id;
      this.schoolIdTest = row.educational_institution_id

      console.log(row, 123465)

      getTchWorkOfStuTchPlan({
        stu_tch_plan_id: row.id,
      }).then((res) => {
        console.log(res, 2134545)
        this.tableDataWork = []
        if (res.stuTchPlanInfo.classWorkInfo != undefined) {
          this.tableDataWork.push(res.stuTchPlanInfo.classWorkInfo)
        }
        if (res.stuTchPlanInfo.homeWorkInfo != undefined) {
          this.tableDataWork.push(res.stuTchPlanInfo.homeWorkInfo)
        }
        console.log(this.tableDataWork, 2134545)
      })
      this.attachment = []
      this.isShowForm = false
      this.stu_name = row.stu_name
      console.log(this.stu_name, 123456)
      this.evaluate_id = ''
      this.markform.markpoint = ''
      this.markform.remark = ''
      this.train_videoList = []
      this.fileList1 = []
      this.fileList = []
      this.stu_tch_plan_id = row.id
      this.scoreList.map((item) => {
        item.star = ''
      })
      this.markform.grantStarNum = 0
      // this.dialogFormVisible2 = true;
      this.drawer1 = true
      this.tchWorkSelfRemarkGet()
    },
    tchWorkSelfRemarkGet() {
      tchWorkSelfRemarkGet({}).then((res) => {
        console.log(res, 12121452)
        this.tagList = res.tchWorkSelfRemarkList
      })
    },
    sumbit5() {
      if (this.remark_id === '') {
        tchWorkSelfRemarkCreateOrUpdate({
          remark: this.remark,
        }).then((res) => {
          console.log(res)
          this.$message.success('添加成功')
          // this.dialogVisible5 = false;
          this.isShowCommonPhrases1 = true

          this.tchWorkSelfRemarkGet()
        })
      } else {
        tchWorkSelfRemarkCreateOrUpdate({
          remark: this.remark,
          remark_id: this.remark_id,
        }).then((res) => {
          console.log(res)
          this.$message.success('编辑成功')
          // this.dialogVisible5 = false;
          this.isShowCommonPhrases1 = true

          this.tchWorkSelfRemarkGet()
        })
      }
    },
    handleChangeRate(val, item) {
      if (item.clickCount > 0 && val === 1) {
        item.star = 0;
        item.clickCount = 0;
      } else {
        item.clickCount += 1;
      }
    }
  },
}
</script>

<style lang="scss" scope>
.topTitle {
  height: 60px;
  background: #fff;
  // margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.studentDetails {
  padding: 10px;
}

.studentDetails .markdown-body {
  background-color: rgb(253, 245, 218);
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.stuInfo {
  background-color: #fff;
  box-sizing: border-box;
  padding: 20px 20px 0px 20px;
  border-radius: 5px;
}

.stuInfo li {
  margin-bottom: 20px;
}

.studentMain {
  background-color: #fff;
  min-height: calc(100vh - 250px);
  box-sizing: border-box;
  padding: 10px 20px 20px 20px;
  border-radius: 5px;
}

.addclass {
  background: #fff9f7;
  border-left: 2px solid #f3ab7b;
}

.addclass1 {
  border-left: 2px solid #fff;
}

/deep/ .el-divider--horizontal {
  margin: 18px 0;
}

// /deep/ .el-upload-list {
//     display: none !important;
// }
/deep/ .pd .el-icon-star-on:before {
  font-size: 14px;
}

.soundRecording {
  position: fixed;
  left: 50%;
  bottom: 10%;
  margin-left: -150px;
  border-radius: 5px;
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.1);
}

// .BtnShow .txttag {
//     padding: 0 15px;
// }

.BtnShow {
  display: none;
}

.txttag:hover .BtnShow {
  display: inline-block;
}
</style>
<style>
.BtnShow .el-button {
  line-height: 0;
}

.el-upload-list {
  display: none !important;
}

.audioStyle::-webkit-media-controls-panel {
  /* background: lightblue; */
  border-radius: 5px;
}

.audioStyle::-webkit-media-controls-current-time-display {
  font-size: 12px;
}

.audioStyle::-webkit-media-controls-time-remaining-display {
  /* color: gray; */
  font-size: 12px;
}

.audioStyle::-webkit-media-controls-play-button {
  background-color: #ffa456;
  border-radius: 50%;
}

.audioStyle {
  border-radius: 0;
}

audio {
  width: 222px !important;
  height: 40px !important;
}
.evaInfo {
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 2px solid #f2f7fd;
}
.evaInfo::after {
  content: "";
  display: table;
  visibility: hidden;
  clear: both;
  height: 0;
}
.evaZanInfo {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 10px 20px;
  background: #f7f7f7;
  border-radius: 6px;
}
.evaZanInfo .zan-num {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}
.evaZanInfo .zan-num svg {
  margin-right: 5px;
}
.evaZanInfo ul {
  display: flex;
  flex-wrap: wrap;
}
.evaZanInfo ul li {
  margin-right: 10px;
  margin-bottom: 10px;
}
.evaZanInfo ul li img {
  display: block;
  width: 35px;
  height: 35px;
  object-fit: cover;
  border-radius: 5px;
}
.evaZanInfo ul li.more-zan {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  color: #1778ff;
  background-color: transparent;
  font-size: 12px;
  cursor: pointer;
}
</style>
